

/* right nav bar */
  function hideNavBar() {
          document.getElementById("right-navBar").classList.add("hidden");
        }

/* right nav bar */


/* easify app hide size */


            setInterval(function() {
    document.querySelectorAll('.tpo_option_type_label').forEach(function(label) {
    
        label.childNodes.forEach(function(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                let text = node.textContent;
                if (text.includes('/')) {
                    node.textContent = text.split('/')[0].trim();
                }
            }
        });
    });
}, 100); 

/* easify app hide size */

/* easify app save calculation */


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const priceElements = document.querySelectorAll(".tpo_additional-price");

    if (priceElements.length === 0) return;

    const firstPriceText = priceElements[0].textContent.trim().replace("$", "");
    const referencePrice = parseFloat(firstPriceText);

    if (isNaN(referencePrice)) return;

    priceElements.forEach((currentPriceElement, index) => {
      const priceText = currentPriceElement.textContent.trim().replace("$", "");
      const currentPrice = parseFloat(priceText);

      if (isNaN(currentPrice)) return;

      let percentageSave = ((referencePrice - currentPrice) / referencePrice) * 100;
      percentageSave = Math.ceil(Math.abs(percentageSave) * 10) / 10; // Yuvarlama

      // "Save X%" etiketi oluştur
      const saveMessage = document.createElement("span");
      saveMessage.textContent = index === 0 ? "Save 0%" : `Save ${percentageSave.toFixed(1)}%`;
      saveMessage.classList.add("discount-info");

      if (index === 0) {
        saveMessage.style.visibility = "hidden";
        saveMessage.style.opacity = "0";
      } else {
        saveMessage.style.color = "green";
      }

      currentPriceElement.appendChild(saveMessage);
    });
  }, 2000); 
});

     
/* easify app save calculation */

document.addEventListener('DOMContentLoaded', function() {
    setInterval(function() {
        var priceElements = document.querySelectorAll('.tpo_additional-price');
        
        priceElements.forEach(function(currentPriceElement, index) {
 
            var currentPriceText = currentPriceElement.textContent.match(/\$([\d,\.]+)/);
            
            if (currentPriceText) {
                var currentPrice = parseFloat(currentPriceText[1].replace(',', ''));

                if (index > 0) {
                    var previousPriceElement = priceElements[index - 1];
                    var previousPriceText = previousPriceElement.textContent.match(/\$([\d,\.]+)/);

                    if (previousPriceText) {
                        var previousPrice = parseFloat(previousPriceText[1].replace(',', ''));

                        var discountPercent = ((previousPrice - currentPrice) / previousPrice) * 100;

                        var discountSpan = currentPriceElement.querySelector('.discount-info');
                        if (!discountSpan) {
                            discountSpan = document.createElement('span');
                            discountSpan.className = 'discount-info'; 
                            discountSpan.style.color = 'green'; 
                            discountSpan.textContent = `Save ${Math.abs(discountPercent).toFixed(2)}%`;

                            currentPriceElement.appendChild(discountSpan);
                        } else {
                            discountSpan.textContent = `Save ${Math.abs(discountPercent).toFixed(2)}%`;
                        }
                    }
                }
            }
        });
    }, 500); 
});


/*  hide double optinos on cart page */

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href === "https://thelabelbarn.com/cart") {
        setInterval(function () {
            const cartItems = document.querySelectorAll(".cart-item__details");

            cartItems.forEach(function (cartItem) {
                const propertiesWrapper = cartItem.querySelector(".tpo_cart-properties-wrapper");
                if (propertiesWrapper) {
                    const productOption = cartItem.querySelector(".product-option");
                    if (productOption) {
                        productOption.style.display = "none";
                    }
                }
            });
        }, 200); 
    }
});

/*  hide double optinos on cart page */


/*  collection hide price */


document.addEventListener("DOMContentLoaded", function () {
    const collectionItems = document.querySelectorAll('.grid__item');

    collectionItems.forEach(item => {
        const hidePriceTag = item.querySelector('.product-tag--hide-price');
        if (hidePriceTag) {
            const priceContainer = item.querySelector('.price__container');
            if (priceContainer) {
                priceContainer.style.display = "none"; 
            }

            const viewOptionSpan = document.createElement("span");
            viewOptionSpan.className = "view-option";
            viewOptionSpan.textContent = "View Options";

            const priceElement = item.querySelector('.price');
            if (priceElement) {
                priceElement.appendChild(viewOptionSpan);
            }
        }
    });
});

/*  collection hide price */

/* change sticker quantity to per sheet */

window.addEventListener('load', function () {
    // Find all the span elements inside .description
    const descriptionElements = document.querySelectorAll('.product__description span');

    // Loop through the span elements to find the ones that contain the keyword "per sheet"
    descriptionElements.forEach(function (spanElement) {
        if (spanElement.innerHTML.includes('per sheet')) {
            // Get the content of the matching span element and wrap it in parentheses
            const textToCopy = `(${spanElement.innerHTML.trim()})`;

            // Find the .quantity .regular element to append the text
            const quantityElement = document.querySelector('.product-form__quantity .quantity__label.form__label');

            if (quantityElement) {
                // Append the text to the existing content with a space
                quantityElement.innerHTML += ` ${textToCopy}`;
            }
        }
    });
});


/* https://thelabelbarn.com/account  */

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/account") {
        const paymentStatusElements = document.querySelectorAll('[data-label="Payment status"]');

        paymentStatusElements.forEach(element => {
            if (element.textContent.trim().includes("Paid")) {
                element.style.position = "relative";

                element.classList.add("paid-status");
            }
        });

        const style = document.createElement("style");
        style.textContent = `
            [data-label="Payment status"].paid-status:after {
                position: absolute;
                content: "";
                right: 50px;
                top: 50%;
                transform: translateY(-50%);
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: url(https://thelabelbarn.com/cdn/shop/files/check-circle.svg?v=1731928984) no-repeat;
                background-size: contain;
            }
        `;
        document.head.appendChild(style);
    }
});




document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/account") { 
        const targetP = document.querySelector('.customer.account div:last-child div:last-child p');

        if (targetP) {
            const styledContent = targetP.innerHTML
                .split('<br>') 
                .map(line => `<span class="line-style">${line.trim()}</span>`) 
                .join('<br>'); 

            targetP.innerHTML = styledContent;
        }
    }
});

/* https://thelabelbarn.com/account  */



/* upsell css */

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        const priceElements = document.querySelectorAll(".gfbFrequentBoughtWidgetProductPriceDiscounted");
        priceElements.forEach(function (priceElement) {
            if (priceElement.textContent.trim() === "$0") {
                const parentContainer = priceElement.closest(".gfbFrequentBoughtWidgetProductContainer");
                if (parentContainer) {
               
                    const styleElement = document.createElement("style");
                    styleElement.textContent = `
                        .gfbFrequentBoughtWidgetContentContainer .gfbFrequentBoughtWidgetProductContainer.free-badge:before {
                            content: "Free";
                            position: absolute;
                            right: 5px;
                            bottom: 5px;
                            background-color: #fff0f5;
                            border-radius: 17px;
                            color: #A52A2A;
                            font-size: 12px;
                            font-weight: 600;
                            padding: 4px
                            12px;
                        }
                    `;
                    document.head.appendChild(styleElement);

                    parentContainer.classList.add("free-badge");
                }
            }
        });
    }, 4000); 
});



/* change sticker quantity to per sheet */

window.addEventListener('load', function () {
    // Find all the span elements inside .description
    const descriptionElements = document.querySelectorAll('.product__description li');

    // Loop through the span elements to find the ones that contain the keyword "per sheet"
    descriptionElements.forEach(function (spanElement) {
        if (spanElement.innerHTML.includes('per sheet')) {
            // Get the content of the matching span element and wrap it in parentheses
            const textToCopy = `(${spanElement.innerHTML.trim()})`;

            // Find the .quantity .regular element to append the text
            const quantityElement = document.querySelector('.quantity__label');

            if (quantityElement) {
                // Append the text to the existing content with a space
                quantityElement.innerHTML += ` ${textToCopy}`;
            }
        }
    });
});


